import { render, staticRenderFns } from "./StoreBlackListPop.vue?vue&type=template&id=6c52dc5b&"
import script from "./StoreBlackListPop.vue?vue&type=script&lang=js&"
export * from "./StoreBlackListPop.vue?vue&type=script&lang=js&"
import style0 from "./StoreBlackListPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports